import React, { forwardRef } from 'react';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { AgGridReactProps, AgGridReact } from '@ag-grid-community/react';
import { GridApi, ColumnApi } from '@ag-grid-community/core';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { getEnvironment } from '../environment';
import useAgGridText from './hooks/useAgGridText';

import '@ag-grid-community/core/dist/styles/ag-grid.css';
import '@ag-grid-community/core/dist/styles/ag-theme-alpine.css';
import './ag-grid-customize.scss';

LicenseManager.setLicenseKey(getEnvironment().AG_GRID_LICENSE);

export type GridProps = Omit<AgGridReactProps, 'children'>;

export type GridRefApi = { api: GridApi; columnApi: ColumnApi };

const Grid = forwardRef<GridRefApi, GridProps>((props, gridRef) => {
  const localeText = useAgGridText();
  const isTest = process.env.TEST;

  return (
    <AgGridReact
      ref={gridRef as any}
      localeText={localeText}
      modules={[ServerSideRowModelModule, RowGroupingModule, ClientSideRowModelModule]}
      rowClass="ag-grid-styled-row"
      isRowSelectable={() => true}
      rowSelection="single"
      suppressCellFocus
      suppressMultiRangeSelection
      suppressMultiSort
      suppressDragLeaveHidesColumns
      debounceVerticalScrollbar
      enableCellTextSelection
      ensureDomOrder
      suppressRowVirtualisation={!!isTest}
      {...props}
    />
  );
});

export default Grid;
